var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"overlay",style:({ zIndex: _vm.zIndex }),on:{"click":function($event){$event.preventDefault();return _vm.closeOverlay.apply(null, arguments)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }